import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase/config";
import { Bar } from "react-chartjs-2";
import { Link } from "react-router-dom";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Enregistrer les composants Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// Fonction utilitaire pour calculer le pourcentage d'avancement d'un dossier (si nécessaire)
const calculateProgress = (phases = []) => {
  if (phases.length === 0) return 0;
  const completed = phases.filter(
    (phase) => phase.status.toLowerCase() === "terminé"
  ).length;
  return Math.round((completed / phases.length) * 100);
};

const DashboardReports = () => {
  const [userCount, setUserCount] = useState(0);
  const [dossierCount, setDossierCount] = useState(0);
  const [overdueCount, setOverdueCount] = useState(0);
  const [sourceReport, setSourceReport] = useState({
    ENERGIS: 0,
    "PLUS QUE PRO": 0,
    "SITE INTERNET": 0,
    RECOMMANDATION: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dossiersSnapshot = await getDocs(collection(db, "dossiers"));
        const usersSnapshot = await getDocs(collection(db, "users"));

        let totalDossiers = dossiersSnapshot.size;
        let overdue = 0;
        const sourcesCount = {
          ENERGIS: 0,
          "PLUS QUE PRO": 0,
          "SITE INTERNET": 0,
          RECOMMANDATION: 0,
        };

        dossiersSnapshot.docs.forEach((doc) => {
          const data = doc.data();
          // Pour le calcul des dossiers en retard, on considère qu'un dossier est en retard si la date limite (dueDate) est passée et le dossier n'est pas clôturé.
          if (data.dueDate) {
            const dueDate = new Date(data.dueDate);
            if (dueDate < new Date() && data.status !== "clôturé") {
              overdue++;
            }
          }
          // Comptabiliser la source du contact (supposons que data.contactSource existe)
          const source = data.contactSource;
          if (source && sourcesCount[source.toUpperCase()] !== undefined) {
            sourcesCount[source.toUpperCase()]++;
          }
        });
        setDossierCount(totalDossiers);
        setOverdueCount(overdue);
        setUserCount(usersSnapshot.size);
        setSourceReport(sourcesCount);
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  // Préparation des données pour le graphique à barres
  const chartData = {
    labels: Object.keys(sourceReport),
    datasets: [
      {
        label: "Sources de contact",
        data: Object.values(sourceReport),
        backgroundColor: [
          "rgba(75, 192, 192, 0.5)",
          "rgba(255, 159, 64, 0.5)",
          "rgba(153, 102, 255, 0.5)",
          "rgba(255, 99, 132, 0.5)",
        ],
      },
    ],
  };

  if (loading) return <div>Chargement des rapports...</div>;

  return (
    <div className="space-y-8">
      {/* Rapport Administratif avec cartes cliquables */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Link to="/admin/users" className="no-underline">
          <div className="border p-4 rounded bg-blue-100 shadow hover:shadow-xl transition transform hover:scale-105 duration-300">
            <h2 className="text-2xl font-bold mb-2">Utilisateurs</h2>
            <p className="text-xl">{userCount}</p>
          </div>
        </Link>
        <Link to="/admin/dossiers" className="no-underline">
          <div className="border p-4 rounded bg-green-100 shadow hover:shadow-xl transition transform hover:scale-105 duration-300">
            <h2 className="text-2xl font-bold mb-2">Dossiers</h2>
            <p className="text-xl">{dossierCount}</p>
          </div>
        </Link>
        <Link to="/admin/dossiers-retard" className="no-underline">
          <div className="border p-4 rounded bg-red-100 shadow hover:shadow-xl transition transform hover:scale-105 duration-300">
            <h2 className="text-2xl font-bold mb-2">Dossiers en retard</h2>
            <p className="text-xl">{overdueCount}</p>
          </div>
        </Link>
      </div>

      {/* Rapport graphique sur la source du contact */}
      <div className="border p-4 rounded bg-white shadow">
        <h2 className="text-2xl font-bold mb-4">Rapport - Source du Contact</h2>
        <Bar data={chartData} options={{ responsive: true }} />
      </div>
    </div>
  );
};

export default DashboardReports;
